import { createStore as _createStore } from 'vuex';

import common from '@/store/modules/common/store';
import localLanding from '@/store/modules/localLanding/store';
import propertyDetails from '@/store/modules/propertyDetails/store';
import propertyValuation from '@/store/modules/propertyValuation/store';
import { splitStoreModule } from '@/store/modules/split/store';

export const createStore = () =>
  _createStore({
    modules: {
      common,
      propertyValuation,
      split: splitStoreModule,
      localLanding,
      propertyDetails,
    },
  });
